const setting = {
  Setting: {
    Contracts: {
      Title: 'مدیریت قراردادها',
      General: ' متن قوانین عمومی',
      Sell: ' متن قوانین فروش',
    },
    Package: {
      Title: 'مدیریت بسته ها',
      PackageType: {
        Normal: 'معمولی',
        Special: 'ویژه',
        Extension: 'تمدید',
        Instant: 'فوری',
      },
      Action: {
        Store: 'افزودن بسته جدید',
        Update: 'ویرایش بسته',
        HaveDiscount: 'تخفیف دار',
        NoDiscount: 'بدون تخفیف',
        Discount: 'تخفیف',
        DiscountType: 'نوع تخفیف',
        DiscountAmount: 'مبلغ تومان',
        DiscountPercent: 'درصد',
        Toman: 'تومان',
      },
      Table: {
        Name: 'عنوان',
        Type: 'نوع',
        PackType: 'نوع بسته',
        SaleType: 'نوع فروش',
        Duration: 'مدت زمان (روز)',
        Price: 'قیمت',
        RevokePrice: 'هزینه ثبت مجدد',
        Description: 'توضیحات',
        Restriction: 'محدودیت',
        isActive: 'وضعیت',
        Risk: 'ریسک',
        DiscountAmount: 'میزان تخفیف',
      },
      Type: {
        Subscription: 'اشتراک',
        Consumable: 'قابل مصرف',
        NonConsumable: 'غیرقابل مصرف',
      },
      Restriction: {
        FullAccess: 'دسترسی کامل',
        SingleApplication: 'تک اپلیکیشن',
        MultiApplication: 'چند اپلیکیشن',
        RegisterUdidOnly: 'ثبت نامی',
      },
      Revoke: {
        Low: 'پایین',
        Medium: 'متوسط',
        High: 'بالا',
      },
      Special: 'پکیج ویژه',
    },
    Cache: {
      Add: {
        Btn: 'افزودن',
        Title: 'افزودن کش',
      },
      Edit: {
        Title: 'ویرایش کش',
      },
      Title: 'کش',
      Key: 'کلید',
      Name: 'نام',
      Expiration: 'انقضاء',
      LastCreated: 'آخرین ایجاد',
      NextCreated: 'بروز رسانی بعدی',
      Clear: {
        Message: 'آیا از پاک کردن این کش مطمئن هستید؟',
      },
      ExpirationType: {
        Title: 'نوع انقضاء',
        Type: {
          Seconds: 'ثانیه',
          Minutes: 'دقیقه',
          Hours: 'ساعت',
          Days: 'روز',
        },
      },
    },
    Sign: {
      Add: {
        Btn: 'افزودن',
        Title: 'افزودن ساین',
      },
      Edit: {
        Title: 'ویرایش ساین',
      },
      Title: 'ساین',
      Table: {
        Title: 'عنوان',
        DailyUse: 'تعداد استفاده در روز',
        CountUsed: 'تعداد استفاده شده امروز',
        LastUsedAt: ' آخرین استفاده در',
      },
      Clear: {
        Message: 'آیا از پاک کردن این ساین مطمئن هستید؟',
      },
      LastRevokeDate: 'تاریخ آخرین دریافت ریووک',
      GetLastRevokeLists: 'دریافت لیست آخرین ریووک ها',
      GetRevokeMassage: 'آیا از دریافت لیست آخرین ریووک ها اطمینان دارید؟',
    },
    Gate: {
      Title: 'درگاه ها',
      Status: 'وضعیت',
      Default: 'پیش فرض',
      Percent: 'درصد کارمزد',
      Max: 'بیشترین کارمزد',
      Min: 'کمترین کارمزد',
      Discount: 'کارمزد',
      Yes: 'دارد',
      No: 'ندارد',
      GateTitle: 'عنوان درگاه',
    },
  },
}

export default setting
